import React, { ChangeEvent, FC } from "react";
import { Text } from "@UI/Components/Text/Text";
import { Textarea } from "@UI/Components/Textarea/Textarea";
import { FormLabel } from "@UI/Components/Form/Form";
import { HintsBox } from "../HintsBox/HintsBox";
import { QuestionFormControl } from "../QuestionFormControl/QuestionFormControl";
import { BaseQuestionProps } from "../types";

export interface TextQuestionProps extends BaseQuestionProps {
  label?: string;
  description?: string;
  hintsTitle?: string;
  hints?: string[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
}

export const TextQuestion: FC<TextQuestionProps> = ({
  label,
  description,
  hintsTitle,
  hints,
  value,
  onChange,
  placeholder = "",
  maxLength,
  isRequired = false,
  isInvalid = false,
  errorMessage = "",
  isDisabled = false,
}) => {
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const next = event.target.value;
    if (typeof maxLength === "number" && next.length > maxLength) return;
    onChange(next);
  };

  const count = value.length;
  const isNearLimit = typeof maxLength === "number" && count >= maxLength * 0.9;

  return (
    <QuestionFormControl
      isRequired={isRequired}
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      isDisabled={isDisabled}
    >
      {label && <FormLabel>{label}</FormLabel>}
      {description && (
        <Text color="gray.600" mb={3}>
          {description}
        </Text>
      )}
      <HintsBox title={hintsTitle} hints={hints} />
      <Textarea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        rows={6}
        bg="white"
      />
      {typeof maxLength === "number" && (
        <Text fontSize="sm" color={isNearLimit ? "orange.500" : "gray.500"} textAlign="right" mt={1}>
          {count}/{maxLength}
        </Text>
      )}
    </QuestionFormControl>
  );
};
